import { Injectable, signal } from '@angular/core';

@Injectable()
export class InlineDetailPanelService<T = unknown> {
    readonly isOpen = signal(false);
    readonly selectedItem = signal<T | null>(null);

    open(item: T): void {
        this.selectedItem.set(item);
        this.isOpen.set(true);
    }

    close(): void {
        this.isOpen.set(false);
        this.selectedItem.set(null);
    }
}
